import {Drawer, styled} from '@mui/material';

const StyledDrawerOverlay = styled(Drawer)`
	& .MuiBackdrop-root {
		background-color: rgba(0, 0, 0, 0.72);
	}

	& .MuiDrawer-paper {
		width: min(414px, calc(100vw - 48px));
		height: calc(100vh - 16px);
		margin: 8px;
		padding: 22px 24px 24px;
		border-radius: 20px;
		box-shadow: 0 12px 32px rgba(17, 24, 39, 0.18);
	}

	${({theme}) => theme.breakpoints.down('sm')} {
		& .MuiBackdrop-root {
			background-color: ${({theme}) => theme.palette.primary.main};
		}

		& .MuiDrawer-paper {
			width: 100%;
			max-width: 100%;
			height: 100vh;
			margin: 77px 0 0;
			padding: 20px 16px;
			border-radius: 16px 16px 0 0;
			box-shadow: none;
		}
	}
`;

const StyledMobileHeader = styled('header')`
	display: none;

	${({theme}) => theme.breakpoints.down('sm')} {
		position: fixed;
		top: 0;
		left: 0;
		z-index: ${({theme}) => theme.zIndex.drawer + 1};
		display: flex;
		align-items: center;
		gap: 12px;
		width: 100%;
		padding: 32px 24px 28px;
		color: ${({theme}) => theme.palette.common.white};
		font-size: 16px;
		font-weight: 700;
		line-height: 1.4;
	}
`;

const StyledMobileHeaderButton = styled('button')`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	padding: 0;
	border: 0;
	background: transparent;
	color: inherit;
	cursor: pointer;

	svg {
		width: 22px;
		height: 22px;
	}
`;

const StyledDrawerContent = styled('section')`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

const StyledDrawerDesktopHeader = styled('header')`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 40px;

	${({theme}) => theme.breakpoints.down('sm')} {
		display: none;
	}
`;

const StyledDrawerTitle = styled('h2')`
	margin: 0;
	color: ${({theme}) => theme.palette.text.primary};
	font-size: 20px;
	font-weight: 700;
	line-height: 1.3;
`;

const StyledCloseButton = styled('button')`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	padding: 0;
	border: 0;
	border-radius: 50%;
	background: transparent;
	color: ${({theme}) => theme.palette.text.secondary};
	cursor: pointer;

	svg {
		width: 24px;
		height: 24px;
	}
`;

const StyledSectionTitle = styled('h3')`
	margin: 0 0 18px;
	color: ${({theme}) => theme.palette.text.primary};
	font-size: 16px;
	font-weight: 700;
	line-height: 1.4;
`;

const StyledOptions = styled('div')`
	display: flex;
	flex-direction: column;
	gap: 14px;
`;

const StyledOptionButton = styled('button')`
	display: grid;
	grid-template-columns: 44px 1fr 28px;
	align-items: center;
	gap: 24px;
	width: 100%;
	min-height: 77px;
	padding: 16px;
	border: 1px solid ${({theme}) => theme.palette.divider};
	border-radius: 10px;
	background: ${({theme}) => theme.palette.common.white};
	color: ${({theme}) => theme.palette.text.primary};
	cursor: pointer;
	text-align: left;
	transition:
		border-color 180ms ease,
		box-shadow 180ms ease;

	span {
		font-size: 14px;
		font-weight: 400;
		line-height: 1.35;
	}

	> svg {
		width: 28px;
		height: 28px;
		color: ${({theme}) => theme.palette.primary.main};
	}

	&:hover {
		border-color: ${({theme}) => theme.palette.primary.main};
		box-shadow: 0 8px 18px rgba(17, 24, 39, 0.08);
	}

	${({theme}) => theme.breakpoints.down('sm')} {
		min-height: 78px;

		> svg {
			color: ${({theme}) => theme.palette.text.primary};
		}
	}
`;

export {
	StyledCloseButton,
	StyledDrawerContent,
	StyledDrawerDesktopHeader,
	StyledDrawerOverlay,
	StyledDrawerTitle,
	StyledMobileHeader,
	StyledMobileHeaderButton,
	StyledOptionButton,
	StyledOptions,
	StyledSectionTitle,
};
